import Alert from 'antd/lib/alert';
import 'antd/lib/alert/style/css';

export default Alert;
